import { useState } from 'react';

interface Props<T> {
	defaultFilter?: T;
}

export default function useFilter<T extends object = Record<string, unknown>>({
	defaultFilter,
}: Props<T>) {
	const [filter, setFilter] = useState<T>(defaultFilter || ({} as T));

	return {
		filter,
		setFilter,
	};
}
